import React, { useEffect } from "react";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { Button, Card, Grid, Paper, Typography } from "@mui/material";
import axios from "axios";
import { Navigate, useNavigate } from "react-router-dom";
import { red } from "@mui/material/colors";
import { useApiClient } from "context/ApiClientContext";

export default function SelectCompany() {
  const navigate = useNavigate();
  const [companies, setCompanies] = React.useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = React.useState("");
  const apiClient = useApiClient();
  
  const fetchDataList = async () => {
    try {
      const response = await axios.get(
        `${apiClient}/company`,
        {
          headers: {
            Authorization:`Bearer ${localStorage.getItem('token')}`,
            Accept: "application/json",
          },
        }
      );


      const data = response.data;
      setCompanies(data);
    } catch (error) {
      console.error("An error occurred:", error.response);
    }
  };

  useEffect(() => {
    fetchDataList();
  }, []);

  const nextPage = () => {
    if (selectedCompanyId) {
      localStorage.setItem("companyId", selectedCompanyId);
      navigate("/");
    } else {
      alert("please select one company");
    }
  };

  const handleChange = (event) => {
    setSelectedCompanyId(event.target.value);
  };

  return (
    <React.Fragment>
      <Grid
        container
        spacing={4}
        direction="column"
        alignItems="center"
        justifyContent="center"
        sx={{ minHeight: "100vh" }}
        bgcolor="primary.main"
      >
        <Paper elevation={2} p={3} sx={{ maxWidth: 600 }}>
          <Grid item xs={8} textAlign="center" mt={2} mx="auto">
            <Typography sx={{ fontWeight: "bold" }}>
              Please select one from your listed company
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <FormControl sx={{ m: 2, minWidth: 320 }} size="small">
              <InputLabel id="demo-select-small-label">Company Name</InputLabel>
              <Select
                labelId="demo-select-small-label"
                id="demo-select-small"
                value={selectedCompanyId}
                label="Company Name"
                onChange={handleChange}
              >
                {companies.map((company, i) => (
                  <MenuItem key={company.id || i} value={company.id}>
                    {company.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} textAlign="center" mb={2}>
            <Button variant="contained" onClick={nextPage} size="small">
              Continue
            </Button>
          </Grid>
        </Paper>
      </Grid>
    </React.Fragment>
  );
}
